import { Tooltip as ChakraTooltip, Portal } from '@chakra-ui/react';

import type { JSX, ReactNode, RefObject } from 'react';

export interface ITooltipProps extends ChakraTooltip.RootProps {
  content: ReactNode;
  disabled?: boolean;
  showArrow?: boolean;
  portalled?: boolean;
  ref?: RefObject<HTMLDivElement>;
  portalRef?: RefObject<HTMLElement>;
  contentProps?: ChakraTooltip.ContentProps;
}

export function Tooltip({
  ref,
  content,
  children,
  disabled,
  showArrow,
  portalRef,
  contentProps,
  portalled = true,
  ...rest
}: ITooltipProps): JSX.Element | ReactNode {
  if (disabled) {
    return children;
  }

  return (
    <ChakraTooltip.Root {...rest}>
      <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
      <Portal disabled={!portalled} container={portalRef}>
        <ChakraTooltip.Positioner>
          <ChakraTooltip.Content ref={ref} {...contentProps}>
            {showArrow && (
              <ChakraTooltip.Arrow>
                <ChakraTooltip.ArrowTip />
              </ChakraTooltip.Arrow>
            )}
            {content}
          </ChakraTooltip.Content>
        </ChakraTooltip.Positioner>
      </Portal>
    </ChakraTooltip.Root>
  );
}
